import { LeanAlert } from "lean-components/LeanComponents"
import { useTranslator } from "lean-util/LeanTranslator"
import { UIDataTableCellActions, UIDataTableCellActive } from "components"

const useColumns = (onUpdateActive, onEdit, onDelete) =>
{
    // MARK: - Properties

    const { translate } = useTranslator()


    // MARK: - Methods

    const showDeleteAlert = (id) =>
    {
        LeanAlert.delete(false, () => { onDelete(id) })
    }

    return [
        {
            accessorKey: "isActive",
            header: () => translate("isActive"),
            cell: info => <UIDataTableCellActive id={info.row.original.id} isActive={info.row.original.isActive} onUpdate={onUpdateActive} />,
            size: 100
        },
        {
            accessorKey: "name",
            header: () => translate("name"),
            cell: info => info.getValue()
        },
        {
            accessorKey: "email",
            header: () => translate("email"),
            cell: info => info.getValue()
        },
        {
            accessorKey: "id",
            header: () => translate("actions"),
            cell: info => <UIDataTableCellActions id={info.row.original.id} onDelete={showDeleteAlert} onEdit={onEdit} />,
            size: 100
        },
    ]
}

export { useColumns }
